module.exports = __webpack_public_path__ + "static/media/arrow-down-yellow.da4320b6.svg";